import Image from 'next/image'
import Wrapper from '../shared/Wrapper'
import CodeNewbieLogo from './assets/code-newbie-logo.png'

export default function FeaturedPublications(): JSX.Element {
  return (
    <Wrapper className="py-20">
      <h1 className="text-3xl font-medium text-center mb-10">Featured in</h1>

      <div className="flex justify-center flex-wrap gap-10 mb-10">
        <ProductHuntLogo />

        <TechCrunchLogo />

        <CourierLogo />

        <Image
          src={CodeNewbieLogo}
          alt="Code newbie logo"
          width={357}
          height={52}
          className="object-contain"
        />
      </div>
    </Wrapper>
  )
}

function ProductHuntLogo(): JSX.Element {
  return (
    <svg
      width="241"
      height="56"
      viewBox="0 0 241 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M28.21 56C43.7899 56 56.4199 43.464 56.4199 28C56.4199 12.536 43.7899 0 28.21 0C12.63 0 0 12.536 0 28C0 43.464 12.63 56 28.21 56Z"
          fill="white"
        />
        <path
          d="M31.9707 14H18.3359V42H23.9779V33.6H31.9707C34.5894 33.6 37.1007 32.5675 38.9524 30.7296C40.804 28.8918 41.8442 26.3991 41.8442 23.8C41.8442 21.2009 40.804 18.7082 38.9524 16.8704C37.1007 15.0325 34.5894 14 31.9707 14ZM31.9707 28H23.9779V19.6H31.9707C33.093 19.6 34.1693 20.0425 34.9629 20.8301C35.7564 21.6178 36.2022 22.6861 36.2022 23.8C36.2022 24.9139 35.7564 25.9822 34.9629 26.7699C34.1693 27.5575 33.093 28 31.9707 28V28Z"
          fill="#1B1B1B"
        />
        <path
          d="M75.2266 37.3346V18.668H83.8659C87.8834 18.668 90.0697 21.363 90.0697 24.5783C90.0697 27.7936 87.8552 30.4606 83.8659 30.4606H79.1642V37.3346H75.2266ZM86.0568 24.5783C86.0568 23.0383 84.8626 22.105 83.3134 22.105H79.1595V27.026H83.3134C84.865 27.026 86.0568 26.0903 86.0568 24.5783Z"
          fill="white"
        />
        <path
          d="M92.4629 37.3335V23.7255H95.9891V25.5128C96.9577 24.3578 98.5938 23.3965 100.256 23.3965V26.8032C99.9361 26.7419 99.6106 26.7145 99.285 26.7215C98.1213 26.7215 96.5698 27.3818 95.9938 28.2335V37.3335H92.4629Z"
          fill="white"
        />
        <path
          d="M101.58 30.3498C101.58 26.5838 104.239 23.3965 108.633 23.3965C113.026 23.3965 115.723 26.5838 115.723 30.3498C115.723 34.1158 113.076 37.3335 108.644 37.3335C104.213 37.3335 101.58 34.1158 101.58 30.3498ZM112.079 30.3498C112.079 28.2895 110.859 26.5022 108.644 26.5022C106.43 26.5022 105.236 28.2895 105.236 30.3498C105.236 32.4102 106.453 34.2255 108.644 34.2255C110.835 34.2255 112.079 32.4335 112.079 30.3498Z"
          fill="white"
        />
        <path
          d="M127.568 37.3346V35.3C127.086 35.9333 126.463 36.4468 125.747 36.7999C125.031 37.153 124.242 37.3361 123.442 37.3346C120.09 37.3346 117.516 34.8053 117.516 30.351C117.516 26.0366 120.036 23.3976 123.442 23.3976C124.243 23.3898 125.034 23.5703 125.751 23.9244C126.468 24.2784 127.091 24.796 127.568 25.4346V18.668H131.115V37.3346H127.568ZM127.568 32.7146V28.0153C126.987 27.1356 125.713 26.5033 124.549 26.5033C122.528 26.5033 121.143 28.069 121.143 30.351C121.143 32.633 122.528 34.2266 124.549 34.2266C125.713 34.2266 126.987 33.6013 127.568 32.7146Z"
          fill="white"
        />
        <path
          d="M143.636 37.3346V35.3279C143.035 35.9673 142.307 36.4758 141.497 36.8212C140.688 37.1667 139.815 37.3415 138.934 37.3346C135.998 37.3346 134.613 35.7386 134.613 33.1556V23.7266H138.14V31.7812C138.14 33.6222 139.11 34.2266 140.606 34.2266C141.197 34.2184 141.778 34.0782 142.307 33.8165C142.836 33.5547 143.299 33.1781 143.662 32.7146V23.7266H147.188V37.3346H143.636Z"
          fill="white"
        />
        <path
          d="M149.803 30.3498C149.803 26.2828 152.793 23.3965 156.893 23.3965C159.636 23.3965 161.298 24.5772 162.185 25.7882L159.883 27.9302C159.575 27.4727 159.154 27.1013 158.66 26.8513C158.166 26.6013 157.616 26.4811 157.062 26.5022C154.928 26.5022 153.432 28.0422 153.432 30.3498C153.432 32.6575 154.928 34.2255 157.062 34.2255C157.617 34.2356 158.166 34.1077 158.659 33.8534C159.152 33.5991 159.573 33.2265 159.883 32.7695L162.185 34.9138C161.298 36.1225 159.636 37.3335 156.893 37.3335C152.805 37.3335 149.803 34.4472 149.803 30.3498Z"
          fill="white"
        />
        <path
          d="M165.207 33.6777V26.778H162.992V23.726H165.207V20.0977H168.733V23.726H171.446V26.778H168.726V32.742C168.726 33.5937 169.168 34.226 169.944 34.226C170.468 34.226 170.969 34.0347 171.161 33.8153L171.909 36.48C171.385 36.9467 170.442 37.334 168.973 37.334C166.509 37.334 165.207 36.0693 165.207 33.6777Z"
          fill="white"
        />
        <path
          d="M193.969 37.3346V29.28H185.245V37.3346H181.312V18.668H185.245V25.871H193.972V18.668H197.94V37.3346H193.969Z"
          fill="white"
        />
        <path
          d="M210.517 37.3346V35.3279C209.916 35.9673 209.187 36.4758 208.378 36.8212C207.569 37.1667 206.696 37.3415 205.815 37.3346C202.879 37.3346 201.494 35.7386 201.494 33.1556V23.7266H205.02V31.7812C205.02 33.6222 205.991 34.2266 207.486 34.2266C208.077 34.2184 208.659 34.0782 209.188 33.8165C209.717 33.5547 210.18 33.1781 210.542 32.7146V23.7266H214.069V37.3346H210.517Z"
          fill="white"
        />
        <path
          d="M226.562 37.3329V28.9749C226.562 27.1339 225.593 26.5016 224.096 26.5016C223.502 26.5116 222.919 26.6554 222.389 26.9222C221.86 27.189 221.398 27.5718 221.04 28.0416V37.3329H217.514V23.7249H221.04V25.4329C221.633 24.7863 222.356 24.271 223.163 23.9208C223.97 23.5706 224.842 23.3934 225.723 23.4006C228.685 23.4006 230.098 25.0479 230.098 27.6333V37.3329H226.562Z"
          fill="white"
        />
        <path
          d="M234.298 33.6777V26.778H232.084V23.726H234.298V20.0977H237.825V23.726H240.538V26.778H237.825V32.742C237.825 33.5937 238.267 34.226 239.042 34.226C239.567 34.226 240.067 34.0347 240.263 33.8153L241.008 36.48C240.483 36.9467 239.541 37.334 238.072 37.334C235.601 37.334 234.298 36.0693 234.298 33.6777Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_988">
          <rect width="241" height="56" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

function TechCrunchLogo(): JSX.Element {
  return (
    <svg
      width="99"
      height="49"
      viewBox="0 0 99 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M49.5 0V16.3333H33V49H16.5V16.3333H0V0H49.5Z" fill="white" />
      <path d="M99 0H66V16.3333H99V0Z" fill="white" />
      <path d="M99 32.6654V48.9987H49.5V16.332H66V32.6654H99Z" fill="white" />
    </svg>
  )
}

function CourierLogo(): JSX.Element {
  return (
    <svg
      width="262"
      height="47"
      viewBox="0 0 262 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M100.039 29.9279C97.5607 39.9239 88.8008 46.5523 78.487 46.5523C65.1172 46.5523 56.0137 35.9837 56.0137 24.557C56.0137 13.7601 64.428 2.67969 78.3725 2.67969C91.7423 2.67969 98.8873 12.904 100.041 19.5305H88.629C87.4187 16.3894 84.1927 12.1601 78.3152 12.1601C70.9965 12.1601 66.9058 18.5013 66.9058 24.5C66.9058 30.9 71.2848 37.0681 78.3725 37.0681C85.172 37.0681 87.9398 31.4119 88.629 29.9279H100.039Z"
          fill="white"
        />
        <path
          d="M118.345 13.0762C129.932 13.0762 135.496 22.1497 135.496 29.9105C135.496 37.6712 129.932 46.7466 118.345 46.7466C106.758 46.7466 101.195 37.6731 101.195 29.9105C101.195 22.1497 106.758 13.0762 118.345 13.0762ZM118.345 37.8995C122.475 37.8995 125.973 34.5338 125.973 29.9086C125.973 25.2872 122.473 21.9196 118.345 21.9196C114.216 21.9196 110.718 25.2853 110.718 29.9086C110.716 34.5338 114.216 37.8995 118.345 37.8995Z"
          fill="white"
        />
        <path
          d="M166.532 45.9143H157.497L157.565 42.1398H157.449C155.492 46.185 151.581 46.5256 149.164 46.5256C147.207 46.5256 142.605 46.0708 139.783 42.5375C137.252 39.4038 136.908 37.1243 136.908 32.7938V13.8789H146.459V31.3705C146.459 33.5358 146.459 37.697 151.581 37.697C154.343 37.697 157.048 36.2719 157.048 31.2582V13.8789H166.599L166.532 45.9143Z"
          fill="white"
        />
        <path
          d="M201.561 13.8555H191.943V45.9148H201.561V13.8555Z"
          fill="white"
        />
        <path
          d="M196.688 0C199.851 0 202.383 2.57955 202.383 5.74093C202.383 8.9023 199.851 11.4819 196.688 11.4819C193.651 11.4819 191.121 8.9023 191.121 5.74093C191.121 2.57955 193.652 0 196.688 0Z"
          fill="white"
        />
        <path
          d="M248.123 45.9201H237.896V13.8534H248.123V45.9201ZM254.784 13.2715C258.552 13.2715 261.445 16.0463 261.445 19.6606C261.445 23.2105 258.552 25.9833 254.784 25.9833C251.083 25.9833 248.19 23.2086 248.19 19.6606C248.19 16.0463 251.083 13.2715 254.784 13.2715Z"
          fill="white"
        />
        <path
          d="M235.632 35.9149C234.071 39.4943 231.815 42.2653 229.095 44.1139C226.432 46.0195 223.251 47.0009 219.953 47.0009C210.753 47.0009 202.943 39.5532 202.943 30.0285C202.943 21.0784 210.001 12.8223 219.779 12.8223C229.557 12.8223 236.731 20.5592 236.731 30.3158C236.731 31.5881 236.615 32.1073 236.501 32.8567H212.431C213.011 36.668 216.193 38.918 219.953 38.918C222.905 38.918 224.467 37.5904 225.795 35.9168H235.632V35.9149ZM227.127 26.3885C226.723 24.4828 224.814 20.9035 219.838 20.9035C214.862 20.9035 212.954 24.4828 212.547 26.3885H227.127Z"
          fill="white"
        />
        <path
          d="M177.91 45.9201H168.488V13.8534H177.91V45.9201ZM184.205 13.2715C187.765 13.2715 190.5 16.0463 190.5 19.6587C190.5 23.2068 187.765 25.9833 184.205 25.9833C180.707 25.9833 177.973 23.2086 177.973 19.6587C177.973 16.0463 180.707 13.2715 184.205 13.2715Z"
          fill="white"
        />
        <path
          d="M28.0226 14.3203C27.8249 14.3203 27.666 14.4805 27.666 14.6775C27.666 14.8727 27.8249 15.0328 28.0226 15.0328C28.2185 15.0328 28.3792 14.8727 28.3792 14.6775C28.3792 14.4805 28.2185 14.3203 28.0226 14.3203Z"
          fill="white"
        />
        <path
          d="M22.4124 2.27734C10.0348 2.27734 0 12.277 0 24.6132C0 36.9475 10.0348 46.9472 22.4124 46.9472C34.7919 46.9472 44.8248 36.9475 44.8248 24.6132C44.8267 12.277 34.7919 2.27734 22.4124 2.27734ZM31.1205 15.825C31.0559 15.8563 30.9746 15.8103 30.9025 15.8177C27.9167 16.1178 30.3408 20.2053 30.3408 20.2053C31.1224 21.8882 31.2517 22.5418 31.224 23.827C31.1556 26.9939 28.9292 29.7318 26.3443 31.2158C26.3424 31.2121 26.3424 31.2084 26.3443 31.2176C26.3443 31.2176 24.7442 33.0718 24.8513 33.8764L25.328 34.9277H26.9004C27.27 34.9277 27.5693 35.1928 27.5693 35.5224H26.9004H25.4759H24.5853H23.9164H23.2494C23.2494 35.1928 23.5487 34.9277 23.9164 34.9277H24.2601C24.2601 34.9277 22.7838 34.2465 22.4974 32.3795C18.2052 33.672 14.5431 31.7203 14.5431 31.7203C14.5431 31.7203 7.81016 34.0936 6.87338 33.3811C7.36302 32.9134 11.1452 31.0206 11.7938 30.6487C23.2272 24.1547 24.1732 21.8955 24.1732 21.8955C25.5294 20.1261 25.2172 18.1321 25.5738 16.2191C25.5738 16.2191 25.8047 14.967 25.8084 14.9523C26.0394 13.8734 26.9688 13.1258 28.0866 13.2216C28.9199 13.2934 29.6036 13.8255 29.914 14.5472C29.914 14.5472 29.6276 14.8161 29.9362 14.956C30.2133 15.0812 30.3186 14.7443 30.3186 14.7443C30.921 14.8768 31.3737 15.2285 31.4661 15.6336C31.4402 15.6888 31.187 15.7956 31.1205 15.825Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_977">
          <rect width="262" height="47" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
